import React from 'react';

import { closedLabel, CourseClosure } from '../../utils/courseClosure';

interface ClosedBadgeProps extends CourseClosure {
  // `dark` on the charcoal Explore and public surfaces, `light` on the white member and admin pages.
  tone?: 'dark' | 'light';
  className?: string;
}

// "Closed December 2025" (or "Closed 2005", or "Closed") as a small pill, next to a closed course's
// name wherever it is listed. Renders nothing for an open course, so a surface can always include
// it. Neutral greys only: closing is information, not an error, and BRAND.md keeps red for errors.
const ClosedBadge: React.FC<ClosedBadgeProps> = ({
  closed,
  closedYear,
  closedMonth,
  tone = 'dark',
  className = '',
}) => {
  const label = closedLabel({ closed, closedYear, closedMonth });
  if (label == null) {
    return null;
  }

  const toneClasses =
    tone === 'dark'
      ? 'border-white/25 bg-white/10 text-white/80'
      : 'border-gray-300 bg-gray-100 text-ink dark:border-white/20 dark:bg-white/10 dark:text-white/80';

  return (
    <span
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded border px-1.5 py-0.5 text-[10px] font-semibold uppercase leading-none tracking-wide ${toneClasses} ${className}`}
    >
      {label}
    </span>
  );
};

export default ClosedBadge;
